<!--
*@description：成果类型树
*@author:rzl
*@date:2022/02/17
-->
<template>
  <div class="dicTree" style="margin-top: 15px;background-color: #f0f0f0;" >
    <a-input style="margin-bottom: 8px; width: 70%;margin-top: 10px"  placeholder="输入关键字搜索" v-model:value="searchVal" @change="searchOnChange" @search="onSearch" />
    <div class="dicTree" style="height:700px;overflow: auto;" >
      <a-tree
        v-if="showData.length > 0"
        :expanded-keys="iExpandedKeys"
        :auto-expand-parent="autoExpandParent"
        default-expanded-keys=""
        :tree-data="showData"
        @expand="onExpand"
        @select="selectShow"
        :replace-fields="{children:'children', key:'id', value: 'id', title: 'label'}"
        style="margin-left: 20px;text-align: left;width: 100%"
      >
        <template #label="{label}">
          <span v-if="label.indexOf(searchValue) > -1">
            {{ label.substr(0, label.indexOf(searchValue)) }}
            <span style="color: #f50">{{ searchValue }}</span>
            {{ label.substr(label.indexOf(searchValue) + searchValue.length) }}
          </span>
          <span v-else>{{ label }}</span>
        </template>
      </a-tree>
    </div>
  </div>

  <div v-if="loadingVisible" class="loading">
    <a-space>
      <a-spin size="large" />
    </a-space>
  </div>
</template>

<script>
import achieveType_api from "../../config/achieveType_api";

export default {
  name: 'achieveTypeTree',
  data () {
    return {
      loadingVisible:false,
      showData: [],
      defaultData: [],
      expandedKeys:[],
      searchVal: "",
      searchValue: "",
      iExpandedKeys: [],
      autoExpandParent: true,
      tree_data: [],
    }
  },
  mounted () {
    //this.getTreeData();
  },
  methods: {
    getTreeData() {
      this.loadingVisible = true;
      this.showData = [];
      this.defaultData = [];
      this.tree_data = [];

      let parms = {
        dictName:null,
        dictCode:null,
      };
      achieveType_api.getAllTree.requestPOSTUrlParam(this,parms,res=>{
        if(res.data.flag){
          let level = 0;
          var tempObj = {
            id:'0',
            label:'成果类型',
            level:level,
          };
         tempObj.children = this.convertToTreedatas_dic(res.data.data,level);
          this.tree_data.push(tempObj);
          for (let i = 0; i < this.tree_data.length; i++) {
            let temp = this.tree_data[i];
            this.defaultData.push(JSON.parse(JSON.stringify(temp)))
            this.showData = [...this.defaultData];
            this.recursionData(this.defaultData);//将每一层数据都赋上title的slot,以高亮显示搜索字段
            this.setThisExpandedKeys(temp)
          }
          this.loadingVisible = false;
        }
        else{
          this.$message.error(res.data.msg)
        }
      })

    },
    recursionData (node) {
      node.forEach(item => {
        item.scopedSlots = { title: 'label' }
        if (item.children && item.children.length) {
          this.recursionData(item.children)
        }
      })
        },
    setThisExpandedKeys(node) {
        //只展开一级目录
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.id)
          //下方代码放开注释则默认展开所有节点
          /* for (let a = 0; a < node.children.length; a++) {
             this.setThisExpandedKeys(node.children[a])
           }*/
        }
      },
      onExpand(expandedKeys) {
          this.iExpandedKeys = expandedKeys
          this.autoExpandParent = false
      },
      searchOnChange () {
        this.showData= [...this.defaultData];
        if (this.searchVal) {
          this.onSearch(this.searchVal);
        } else {
          this.searchValue = "";
          this.iExpandedKeys = [this.showData[0].id];
        }
      },
      onSearch(val){
        const value = val
        this.searchValue = value
        if (value != '') {
          let treeData = JSON.parse(JSON.stringify(this.showData));

          let listData = this.getkeyList(treeData, val);
          this.showData= [...listData];
          // 展开所有树数据
          this.expandAll(this.showData);
        } else {
          this.iExpandedKeys = [this.showData[0].id];
        }
      },
    //获取节点中含有value的所有key集合
    getkeyList(tree,val){
      var returnData = [];
      //遍历数据
      for(var i = 0; i < tree.length; i++){
        let tempObj =[];
        let str = tree[i].label;
        if(str.indexOf(val) > -1){
          tempObj = tree[i];
          returnData.push(tempObj);
        }else{
          if(tree[i].children != null && tree[i].children.length > 0){
            let children = this.getkeyList(tree[i].children,val);
            if(children.length > 0){
              tempObj = tree[i];
              tempObj.children = children;
              returnData.push(tempObj);
            }
          }
        }
      }

      return returnData;
    },
      expandAll (node) {
        node.forEach(item => {
          if (item.children && item.children.length) {
            this.iExpandedKeys.push(item.id)
            this.expandAll(item.children)
          }
        })
      },
    selectShow(expandedKeys,info){
      let label = info.selectedNodes[0].props.label;
      let level = info.selectedNodes[0].props.level;
      let parms = {
        id:expandedKeys[0],
        label:label,
        level:level,
      };
      this.$emit("event",this.$GetEmitData(this.$eventTags.search,parms));
    },

    /**
     * 多级
     * 树选择框,构造转换，转换后端数据为树形选择需要的数据
     * @param data  后端数据
     * @returns {[]}  返回结构
     */
    convertToTreedatas_dic(data,level){
      var returnData = [];
      //遍历数据
      for(var i = 0; i < data.length; i++){
        var tempObj = {
          id:data[i].id,
          label:data[i].name,
          level:level + 1,
        };

        //判断是否存在子节点，如果存在则递归
        if(data[i].children != null && data[i].children.length > 0){
          tempObj.children = this.convertToTreedatas_dic(data[i].children,level + 1);
        }
        //push到数据数组中
        returnData.push(tempObj);
      }
      return returnData;
    },

  }

}
</script>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.loading{
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 62, 80, 0.5);
  display:flex;
  justify-content:center;
  align-items:center;
}
</style>
